import React, { useState, useEffect } from 'react';
import { FiClock, FiTool } from 'react-icons/fi';
import blogServices from '../services/BlogServices';

function MaintenancePage() {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const [endTime, setEndTime] = useState(null);
    const [message, setMessage] = useState('We are performing scheduled maintenance.');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        blogServices.getMaintenanceStatus()
            .then(res => {
                if (res.data.end_time) {
                    setEndTime(new Date(res.data.end_time));
                }
                if (res.data.message) {
                    setMessage(res.data.message);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (!endTime) return;

        const calculateTimeLeft = () => {
            const difference = endTime - new Date();

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60),
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        calculateTimeLeft();
        const timer = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(timer);
    }, [endTime]);

    if (loading) {
        return (
            <div className="min-h-screen bg-zinc-900 flex items-center justify-center">
                <div className="animate-spin w-8 h-8 border-2 border-[#FFC000] border-t-transparent rounded-full"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-6 relative overflow-hidden">

            <div
                className="absolute inset-0 opacity-[0.15]"
                style={{
                    backgroundImage: `radial-gradient(circle at 1px 1px, rgb(63 63 70) 1.5px, transparent 0)`,
                    backgroundSize: '28px 28px'
                }}
            ></div>

            <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#FFC000]/5 rounded-full blur-3xl pointer-events-none"></div>

            <div className="relative max-w-2xl text-center">
                <div className="mb-8 flex justify-center">
                    <div className="w-20 h-20 rounded-full bg-[#FFC000]/10 border border-[#FFC000]/20 flex items-center justify-center">
                        <FiTool className="w-10 h-10 text-[#FFC000]" />
                    </div>
                </div>

                <span className="text-xs font-bold uppercase tracking-widest text-[#FFC000] mb-4 block">
                    Guardhart Security
                </span>

                <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight">
                    Under Maintenance
                </h1>

                <p className="text-lg text-zinc-400 mb-12 leading-relaxed">
                    {message}
                </p>

                {endTime && (
                    <div className="mb-12">
                        <div className="flex items-center justify-center gap-2 text-sm text-zinc-500 mb-6">
                            <FiClock className="w-4 h-4" />
                            <span>Expected back online in:</span>
                        </div>

                        <div className="grid grid-cols-4 gap-4 max-w-md mx-auto">
                            <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
                                <div className="text-3xl md:text-4xl font-bold text-[#FFC000] mb-1">
                                    {String(timeLeft.days).padStart(2, '0')}
                                </div>
                                <div className="text-xs text-zinc-500 uppercase tracking-widest">
                                    Days
                                </div>
                            </div>
                            <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
                                <div className="text-3xl md:text-4xl font-bold text-[#FFC000] mb-1">
                                    {String(timeLeft.hours).padStart(2, '0')}
                                </div>
                                <div className="text-xs text-zinc-500 uppercase tracking-widest">
                                    Hours
                                </div>
                            </div>
                            <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
                                <div className="text-3xl md:text-4xl font-bold text-[#FFC000] mb-1">
                                    {String(timeLeft.minutes).padStart(2, '0')}
                                </div>
                                <div className="text-xs text-zinc-500 uppercase tracking-widest">
                                    Minutes
                                </div>
                            </div>
                            <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
                                <div className="text-3xl md:text-4xl font-bold text-[#FFC000] mb-1">
                                    {String(timeLeft.seconds).padStart(2, '0')}
                                </div>
                                <div className="text-xs text-zinc-500 uppercase tracking-widest">
                                    Seconds
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="border-t border-zinc-800 pt-8">
                    <p className="text-sm text-zinc-500 mb-2">Need immediate assistance?</p>
                    <a
                        href="tel:+254714843383"
                        className="text-[#FFC000] hover:underline font-medium"
                    >
                        +254 117 666 000
                    </a>
                </div>

            </div>
        </div>
    );
}

export default MaintenancePage;